import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

function PreviewOverlay({ copy, subcopy, buttonText, buttonAction }) {
  return (
    <div className="notice-container">
      <div className="notice-container__background" />
      <div className="preview-hidden">
        <div className="preview-hidden-body">
          <i className="zolaicon zolaicon-closed-eye" />
          <p className="large-cta">{copy}</p>
          <p className="margin-bottom-2x">{subcopy}</p>
          {buttonText && (
            <div>
              <ButtonV2 variant="secondary" onClick={buttonAction}>
                {buttonText}
              </ButtonV2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

PreviewOverlay.propTypes = {
  copy: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.node]),
  subcopy: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.node]),
  buttonText: PropTypes.string,
  buttonAction: PropTypes.func,
};

export default PreviewOverlay;
